import useCheckoutState from './useCheckoutState';
import useMatchMedia from './useMatchMedia';

/**
 * Returns the effective color mode ('light' | 'dark') for the current checkout.
 *
 * Resolution order:
 *  1. Explicit theme setting ('light' or 'dark') — always wins.
 *  2. 'system' — in a preview with a toggle, follows the toggle; in live and in
 *     the store-served preview (no toggle), follows the OS preference
 *     reactively via matchMedia listener.
 *  3. Unset (undefined/null, i.e. the default was stripped) — treated as 'light'.
 */
export default function useEffectiveColorMode() {
  const { theme, previewColorMode, isPreview } = useCheckoutState();
  const colorScheme = theme?.tokens?.colors;

  const systemPrefersDark = useMatchMedia('(prefers-color-scheme: dark)');

  if (colorScheme === 'dark') return 'dark';
  if (colorScheme === 'light') return 'light';

  if (colorScheme === 'system') {
    if (isPreview && previewColorMode) return previewColorMode === 'dark' ? 'dark' : 'light';
    return systemPrefersDark ? 'dark' : 'light';
  }

  // undefined/null — default is 'light' (stripped by stripSystemDefaults)
  return 'light';
}
